import { render } from "./BomValidationResultsDetails.vue?vue&type=template&id=9fc0afce&scoped=true"
import script from "./BomValidationResultsDetails.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsDetails.vue?vue&type=script&lang=js"

import "./BomValidationResultsDetails.vue?vue&type=style&index=0&id=9fc0afce&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc0afce"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
